// ═══════════════════════════════════════════════════════════
// GabChart — Chart.js wrapper for analytics pages
// ═══════════════════════════════════════════════════════════

import { Bar, Doughnut, Line } from 'react-chartjs-2';
import {
  Chart as ChartJS, CategoryScale, LinearScale, BarElement, ArcElement,
  PointElement, LineElement, Title, Tooltip, Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, ArcElement, PointElement, LineElement, Title, Tooltip, Legend);

interface ChartData {
  labels: string[];
  values: number[];
  colors?: string[];
}

// Mirror --data-viz-* token hex values
const DEFAULT_COLORS = ['#7589FF', '#08A847', '#C68700', '#D33423', '#0285C4', '#A627FF', '#939598', '#F86A0B'];

const TICK_FONT = { size: 11 } as const;

export function GabBarChart({ data, height = 220 }: { data: ChartData; height?: number }) {
  return (
    <div style={{ flex: 1, minHeight: height }}>
      <Bar
        data={{
          labels: data.labels,
          datasets: [{ data: data.values, backgroundColor: data.colors || DEFAULT_COLORS.slice(0, data.values.length), borderRadius: 4 }],
        }}
        options={{ responsive: true, maintainAspectRatio: false, plugins: { legend: { display: false } }, scales: { y: { beginAtZero: true, ticks: { font: TICK_FONT } }, x: { ticks: { font: TICK_FONT } } } }}
      />
    </div>
  );
}

export function GabDonutChart({ data, height = 220 }: { data: ChartData; height?: number }) {
  return (
    <div style={{ flex: 1, minHeight: height }}>
      <Doughnut
        data={{
          labels: data.labels,
          datasets: [{ data: data.values, backgroundColor: data.colors || DEFAULT_COLORS.slice(0, data.values.length) }],
        }}
        options={{ responsive: true, maintainAspectRatio: false, plugins: { legend: { position: 'right', labels: { font: TICK_FONT, boxWidth: 10 } } } }}
      />
    </div>
  );
}

export function GabLineChart({ data, height = 220, label = '' }: { data: ChartData; height?: number; label?: string }) {
  return (
    <div style={{ flex: 1, minHeight: height }}>
      <Line
        data={{
          labels: data.labels,
          datasets: [{ label, data: data.values, borderColor: 'var(--color-primary-700)', backgroundColor: 'rgba(75,63,255,0.1)', fill: true, tension: 0.3 }],
        }}
        options={{ responsive: true, maintainAspectRatio: false, plugins: { legend: { display: !!label } }, scales: { y: { beginAtZero: true, ticks: { font: TICK_FONT } }, x: { ticks: { font: TICK_FONT } } } }}
      />
    </div>
  );
}
